import { createInvalidAccessError } from '../factories/invalid-access-error';
export var wrapIIRFilterNodeGetFrequencyResponseMethod = function wrapIIRFilterNodeGetFrequencyResponseMethod(nativeIIRFilterNode) {
  nativeIIRFilterNode.getFrequencyResponse = function (getFrequencyResponse) {
    return function (frequencyHz, magResponse, phaseResponse) {
      if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) {
        throw createInvalidAccessError();
      }
      return getFrequencyResponse.call(nativeIIRFilterNode, frequencyHz, magResponse, phaseResponse);
    };
  }(nativeIIRFilterNode.getFrequencyResponse);
};